import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface PatternChange {
  device_id: string;
  pattern: string;
  started_at: string;
}

// Covers the full device_logs archive (pattern events go back to April 2026).
const DAYS = 400;

/**
 * Server-aggregated pattern history for the visualization page: the dominant
 * light pattern per hour per sculpture, aggregated in the database by the
 * get_pattern_changes RPC, so the browser receives thousands of rows instead
 * of hundreds of thousands. `missing` means the RPC could not be read.
 */
export function useDeviceMetrics(days = DAYS) {
  const [patternChanges, setPatternChanges] = useState<PatternChange[] | null>(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    const since = new Date(Date.now() - days * 864e5).toISOString();

    (async () => {
      const { data, error } = await (supabase as any)
        .rpc('get_pattern_changes', { since })
        .limit(50000);
      if (error) {
        setMissing(true);
        return;
      }
      setPatternChanges(data as PatternChange[]);
    })().catch(() => setMissing(true));
  }, [days]);

  return {
    patternChanges,
    missing,
    loading: patternChanges === null && !missing,
  };
}
